import Model from "./base/model";

class pgrFile extends Model{
  resourceName() {
    return "pgr_files";
  }

  fields() {
    return {
      company_id: "",
      pgr_path: "",
      pgr_name: "",
      created_at: "",
    }
  }
}

export default new pgrFile();
